import { motion, useReducedMotion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { ButtonLink } from '../ui';

export function CtaSection() {
  const reduced = useReducedMotion();

  return (
    <section className="py-24 md:py-32">
      <div className="container-page">
        <Reveal>
          <div className="grain relative isolate overflow-hidden rounded-2xl bg-ink-900 px-6 py-20 text-center text-sand-100 sm:px-16 md:rounded-[2.75rem] md:py-28">
            <div className="aurora opacity-40" />

            {!reduced ? (
              <motion.div
                aria-hidden
                animate={{ rotate: 360 }}
                transition={{ duration: 60, repeat: Infinity, ease: 'linear' }}
                className="pointer-events-none absolute -right-24 -top-24 size-72 rounded-full border border-white/10"
              >
                <span className="absolute left-1/2 top-0 size-2 -translate-x-1/2 rounded-full bg-clay-400" />
              </motion.div>
            ) : null}

            <div className="relative mx-auto max-w-2xl">
              <div className="eyebrow mb-5 text-sand-400">Регистрация по коду</div>
              <h2 className="display text-[clamp(2.25rem,5vw,4rem)]">
                Соберите следующее путешествие как надо
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-sand-300">
                Без почты, телефона и паспорта — только логин, пароль и код приглашения. Персональных
                данных мы не храним, потому что они нам не нужны.
              </p>
              <div className="mt-10 flex flex-wrap justify-center gap-3">
                <ButtonLink to="/register" size="lg">
                  Создать аккаунт
                </ButtonLink>
                <ButtonLink to="/gallery" variant="outline" size="lg" className="border-white/20 text-sand-100 hover:bg-white/10">
                  Сначала посмотреть
                </ButtonLink>
              </div>
              <p className="mt-6 text-sm text-sand-400">
                Нет кода? Откройте любой публичный маршрут — для просмотра аккаунт не нужен.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
